"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
exports.debug = require('debug');
function getProperty(obj, property) {
    var firstDot = property.indexOf('.');
    if (firstDot >= 0) {
        return getProperty(getProperty(obj, property.substring(0, firstDot)), property.substring(firstDot + 1));
    }
    else {
        if (obj.hasOwnProperty(property)) {
            return obj[property];
        }
        else {
            throw new Error("property " + property + " was not found");
        }
    }
}
exports.getProperty = getProperty;
function getOptionalProperty(obj, property, defaultValue, defaultValueProvider) {
    var firstDot = property.indexOf('.');
    if (firstDot >= 0) {
        return getOptionalProperty(getOptionalProperty(obj, property.substring(0, firstDot), {}), property.substring(firstDot + 1), defaultValue, defaultValueProvider);
    }
    else {
        var value = obj.hasOwnProperty(property)
            ? getProperty(obj, property)
            : undefined;
        if (value !== null && value !== undefined) {
            return value;
        }
        else {
            return defaultValue
                ? defaultValue
                : defaultValueProvider
                    ? defaultValueProvider()
                    : undefined;
        }
    }
}
exports.getOptionalProperty = getOptionalProperty;
function getRequiredProperty(obj, property) {
    var value = getProperty(obj, property);
    if (value !== null && value !== undefined) {
        return value;
    }
    else {
        throw new Error("value of property " + property + " was not defined");
    }
}
exports.getRequiredProperty = getRequiredProperty;
function traverseObject(obj, callback) {
    var result = {};
    lodash_1.forOwn(obj, function (value, key) {
        if (lodash_1.isPlainObject(value)) {
            value = traverseObject(value, callback);
        }
        else if (Array.isArray(value) &&
            allArrayItemsArePlainObjects(value)) {
            value = value.map(function (item) { return traverseObject(item, callback); });
        }
        result[key] = callback(key, value);
    });
    return result;
}
exports.traverseObject = traverseObject;
function allArrayItemsArePlainObjects(array) {
    return array.every(function (item) { return lodash_1.isPlainObject(item); });
}
exports.allArrayItemsArePlainObjects = allArrayItemsArePlainObjects;
// tslint:disable
function uniqueId() {
    return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
exports.uniqueId = uniqueId;
function createLogger(scope) {
    return new skynet_store_utilities_1.Logger('dynamic-layout-interpreter', scope);
}
exports.createLogger = createLogger;
//# sourceMappingURL=interpreter-utils.js.map